import React, { memo } from 'react';

const FooterStock = () => {
    return (
        <a
            href='https://docs.vmass.vn/quan-ly/nguyen-lieu'
            target='_blank'
            className='mb-0 pl-2'
        >
            Hướng dẫn
        </a>
    );
};

export default memo(FooterStock);
